export default {
    path: 'inventory',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/common/CommonList'),
    meta: {title:'结算清单查看'}
}